<!-- 异常记录详细 -->
<template>
  <div class='h-100'>
    <div style='line-height: 40px;' class='uk-text-center bg-theme color-white'>
      {{ $t('integration.details_of_abnormal_content') }}
    </div>
    <div v-if='exDetail.ex' class='border m-0-auto pd-5 uk-margin-top uk-position-relative'
         style='width: 97%;height: calc(100% - 2rem);'>
      <div class='h-100' style='overflow-y: auto;'>
        <div :class='exType[exDetail.ex.exCatalog].cls' style='width: 20%;'>
          {{ exDetail.exCatalog[exDetail.ex.exCatalog].name }}
        </div>

        <!-- 所属 -->
        <div class='r-default border w-95 m-0-auto uk-text-center uk-margin-small-top'>
          <div class='bg-theme color-white lh-30'>{{ $t('integration.belonging_to') }}</div>
          <div class='lh-30'>{{ exDetail.ex.sceneName }}</div>
        </div>

        <!-- 监测点 -->
        <div class='r-default border w-95 m-0-auto uk-text-center uk-margin-small-top'>
          <div class='bg-theme color-white lh-30'>{{ $t('integration.monitoring_point') }}</div>
          <div class='lh-30'>{{ exDetail.ex.carrierName }}</div>
        </div>

        <!-- 异常内容 -->
        <div class='r-default border w-95 m-0-auto uk-text-center lh-30 uk-margin-small-top'>
          <div class='bg-theme color-white '>{{ $t('integration.abnormal_content') }}</div>
          <div style='height: 3rem; overflow-y: auto;'>
            <div class='border w-95 m-0-auto  mt-5 mb-5' :key='record.id'
                 v-for='record in exDetail.ex.recordDetails'>
              <div>
                <div class='bg-theme color-white'>
                  {{ exDetail.ex.carrierDeviceName }}
                </div>
                <div class='pd-5' v-if='record.content'>
                  <!-- 循环点 -->
                  <div class='border mb-5'>
                    <div class='bd-b'>{{ record.content.min }}{{ record.content.unit }} ~ {{
                        record.content.max }}{{ record.content.unit }}
                    </div>
                    <div class='uk-flex uk-flex-between'>
                      <div class='bd-r uk-flex-1'>{{ $timetransition(record.recordTime) }}</div>
                      <div style='width: 1.5rem;' v-range='[record.content.val, record.content]'>{{
                          record.content.val }}{{ record.content.unit }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class='mb-5'>
                  {{ $timetransition(record.recordTime) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 处理 -->
        <div class='r-default border w-95 m-0-auto uk-text-center lh-30 uk-margin-small-top'>
          <div class='bg-theme color-white'>{{ $t('integration.handle') }}</div>
          <div class='pd-10'>
            <HandleEx ref='handleEx' :detail='exDetailArr' :reason='exDetail.reason'></HandleEx>
            <el-button style='margin-right: 5px;' type='primary' @click='handle'>{{ $t('integration.handle') }}
            </el-button>
            <!--<el-button type='primary' @click='handleWithStop'>{{ $t('integration.process_and_stop_alarms') }}-->
            <!--</el-button>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExDetail from '@/pages/abnormal/component/ExDetailDia/ExDetail'
import { getExDetail, handleEx } from '@/api/modules/general'
import HandleEx from '@/pages/abnormal/component/HandleExDia/HandleEx'
import { exType } from '@/utils/convert'

export default {
  components: {
    ExDetail,
    HandleEx
  },
  data () {
    return {
      exDetail: {},
      reasonList: [],
      model: {},
      contacts: null
    }
  },
  computed: {
    exType () {
      return exType
    },
    exDetailArr () {
      return [this.exDetail.ex]
    }
  },
  mounted () {
    // http://192.168.0.57:3001/exDetail?exId=0b468a8f409c42cc9ca84cc317cb61c7&sceneId=1&contants=
    const {
      exId,
      contacts
    } = this.$route.query
    this.contacts = contacts
    getExDetail(exId).then(({ result }) => {
      result.ex.recordDetails = result.ex.recordDetails.map(item => {
        if (item.content) {
          item.content = JSON.parse(item.content)
        }
        return item
      })
      this.exDetail = result
    })
  },
  methods: {
    async handle () {
      const params = await this.$refs.handleEx.getData()
      handleEx({
        exIds: [this.exDetail.ex.id],
        process: {
          ...params,
          processor: this.contacts
        }
      }).then(({ result }) => {
        this.$refs.handleEx.handleResult(result)
      })
    },
    async handleWithStop () {
      const params = await this.$refs.handleEx.getData()
      handleEx({
        exIds: [this.exDetail.ex.id],
        carrierId: this.exDetail.ex.carrierId,
        process: {
          ...params,
          processor: this.contacts
        }
      }).then(({ result }) => {
        this.$refs.handleEx.handleResult(result)
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.ex-data-tag, .ex-connection-tag, .ex-power-tag {
  position: absolute;
  left: 50%;
  top: -15px;

  transform: translateX(-50%);
}
</style>
